import { CartaoContainer, ImagemContainer, Rotulo, Corpo } from './styles';
import { useRouter } from 'next/navigation';
import Image from 'next/image';
import { useTheme } from 'styled-components';

import Text from '@/components/atoms/Text';
import InformacoesPublicacao from '../InformacoesPublicacao';
import Heading from '@/components/atoms/Heading';

export type PropsRecomendacaoPublicacao = {
  imagem: string;
  titulo: string;
  subtitulo: string;
  autor: string;
  imagemAutor?: string;
  rotulo: string;
  link: string;
  original?: boolean;
  data: string;
  duracao: string;
};

export function RecomendacaoPublicacao({
  imagem,
  titulo,
  subtitulo,
  autor,
  imagemAutor,
  rotulo,
  link,
  data,
  duracao,
}: PropsRecomendacaoPublicacao) {
  const { push } = useRouter();
  const theme = useTheme();

  return (
    <CartaoContainer>
      <ImagemContainer>
        <a onClick={() => push(link)}>
          <Image
            src={imagem}
            alt={`Imagem de ${titulo}`}
            fill
            style={{
              objectFit: 'cover',
              borderRadius: 6,
              cursor: 'pointer',
            }}
            sizes="100vw"
            placeholder="blur"
            blurDataURL="/assets/images/placeholder.png"
          />
          <Rotulo>
            <Text
              $size={1}
              $color={theme.tokens.colors.black_contrast}
              $highContrast={false}
              $weight="medium"
              $fontFamily="news"
              $align="left"
              $text={rotulo}
            />
          </Rotulo>
        </a>
      </ImagemContainer>
      <Corpo>
        <a onClick={() => push(link)}>
          <Heading
            $priority={4}
            $size={3}
            $color={theme.tokens.colors.black_contrast}
            $highContrast={false}
            $weight="bold"
            $fontFamily="news"
            $align="left"
            $text={titulo}
            style={{
              WebkitLineClamp: 3,
              overflow: 'hidden',
              paddingTop: theme.spacing[4],
            }}
          />
        </a>
        <Text
          $size={1}
          $color={theme.tokens.colors.news.description}
          $highContrast={false}
          $weight="bold"
          $fontFamily="news"
          $align="left"
          $text={subtitulo}
        />
        <InformacoesPublicacao
          image={imagemAutor}
          author={autor}
          date={data}
          duration={Number(duracao)}
          style={{ paddingTop: theme.spacing[2] }}
        />
      </Corpo>
    </CartaoContainer>
  );
}
